module.exports = __webpack_public_path__ + "static/media/newsletter_desktop.dd8d56ff.webp";